import type { TrackStats } from '../../analysis/zones/TrackZoneTypes'

const TRACK_STATS_FIELDS: (keyof TrackStats)[] = [
  'totalZones',
  'highVarianceZones',
  'overallConsistency',
  'totalTimeLossMs',
  'trackLength',
]

type Fields = Record<string, unknown>

export function hasSummaryShape(laps: unknown, analysis: unknown): boolean {
  return isListOf(laps, isSummaryLap) && isStoredAnalysis(analysis)
}

function isStoredAnalysis(value: unknown): boolean {
  if (!isObject(value)) return false
  return (
    isListOf(value.zones, isStoredZone) &&
    isListOf(value.focusZoneIds, isText) &&
    isListOf(value.improveZoneIds, isText) &&
    isListOf(value.solidZoneIds, isText) &&
    isObject(value.zoneLapData) &&
    Object.values(value.zoneLapData).every((rows) =>
      isListOf(rows, isObject)
    ) &&
    isTrackStats(value.trackStats) &&
    (value.trackGradient === null || isListOf(value.trackGradient, isObject))
  )
}

function isSummaryLap(value: unknown): boolean {
  return (
    isObject(value) &&
    typeof value.lapId === 'string' &&
    typeof value.lapNumber === 'number' &&
    typeof value.lapTimeMs === 'number' &&
    typeof value.excludedByDefault === 'boolean'
  )
}

function isStoredZone(value: unknown): boolean {
  return (
    isObject(value) &&
    typeof value.id === 'string' &&
    typeof value.type === 'string' &&
    isObject(value.consensus) &&
    isObject(value.variance) &&
    isObject(value.variance.details) &&
    isObject(value.impact) &&
    (value.consistencyPercent === null ||
      (isObject(value.consistencyPercent) &&
        isListOf(value.consistencyPercent.rows, isObject)))
  )
}

function isTrackStats(value: unknown): boolean {
  return (
    isObject(value) &&
    TRACK_STATS_FIELDS.every((field) => typeof value[field] === 'number')
  )
}

function isListOf(
  value: unknown,
  isEntry: (entry: unknown) => boolean
): boolean {
  return Array.isArray(value) && value.every(isEntry)
}

function isText(value: unknown): boolean {
  return typeof value === 'string'
}

function isObject(value: unknown): value is Fields {
  return (
    typeof value === 'object' &&
    value !== null &&
    !Array.isArray(value) &&
    !(value instanceof Date)
  )
}
